"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppWithTrans = void 0;
const React = require("react");
const hoistNonReactStatic = require("hoist-non-react-statics");
const gettext_1 = require("./gettext");
const context_1 = require("./context");
function AppWithTrans(WrapperComponent) {
    class WithTransPageComponent extends React.Component {
        constructor() {
            super(...arguments);
            this.gettext = (msgid, argArrs = []) => {
                var _a;
                return gettext_1.gettext(((_a = this.props) === null || _a === void 0 ? void 0 : _a.localeObj) || {}, msgid, argArrs);
            };
        }
        render() {
            return (React.createElement(context_1.I18NContext.Provider, { value: {
                    gettext: this.gettext,
                    localeObj: this.props.localeObj,
                } },
                React.createElement(WrapperComponent, Object.assign({}, this.props))));
        }
    }
    return hoistNonReactStatic(WithTransPageComponent, WrapperComponent);
}
exports.AppWithTrans = AppWithTrans;
//# sourceMappingURL=AppWithTrans.js.map